import React from "react";
import hocWidthWindow from "../../HOC/HocWidthWindow";

import SolicitudView from "./SolicitudView";

const Solicitud = (props) => {
    return (<SolicitudView ruta={props.location.pathname}></SolicitudView>)
}
export default hocWidthWindow(Solicitud);